import { render, staticRenderFns } from "./ReviewsSummaryInline.vue?vue&type=template&id=00f3ff6a&scoped=true&"
import script from "./ReviewsSummaryInline.vue?vue&type=script&lang=js&"
export * from "./ReviewsSummaryInline.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSummaryInline.vue?vue&type=style&index=0&id=00f3ff6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f3ff6a",
  null
  
)

export default component.exports